// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Styles_skeleton__a5tTR","skeleton__historyRow":"Styles_skeleton__historyRow__HNXpv","skeleton__historyViewMore":"Styles_skeleton__historyViewMore__ET5Qe"};